import validatorResult from '@/directives/validator/common/result/validatorResult';

// eslint-disable-next-line max-len,no-control-regex,no-useless-escape
const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export default ({ required = true } = {}) => (value) => {
  const isValid = (!required && !value) || regex.test(value);
  return validatorResult(isValid, 'E-postadressen är inkorrekt');
};
